import script from "./Comments.vue?vue&type=script&lang=ts&setup=true"
export * from "./Comments.vue?vue&type=script&lang=ts&setup=true"

import "./Comments.vue?vue&type=style&index=0&id=ef154fce&scoped=true&lang=scss"
import "./Comments.vue?vue&type=style&index=1&id=ef154fce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef154fce"]])

export default __exports__